module.exports = __webpack_public_path__ + "img/tr_tr.e9896c55.png";